import React from 'react';
import { Loader2 } from 'lucide-react';

const Button = ({
  label = "Button",
  loadingLabel = "Loading...",
  disabled = false,
  loading = false,
  type = "button",
  onClick,
  className = "",
  icon,
  buttonParent,
  iconPosition = "right"
}) => {
  return (
    <div className={`my-2 ${buttonParent}`}>
      <button
        className={`py-2 5xl:py-3 md:px-7 px-5 xl:text-lg lg:text-base text-base min-w-fit justify-center flex items-center duration-300 transition-all gap-2 ${disabled || loading ? "bg-opacity-50 cursor-not-allowed" : "cursor-pointer hover:scale-105"
          } ${className}`}
        onClick={!disabled && !loading ? onClick : undefined}
        disabled={disabled || loading}
        type={type}
        aria-busy={loading}
      >
        {loading ? (
          <>
            <Loader2 className="h-8 w-8 animate-spin" />
            <span>{loadingLabel}</span>
          </>
        ) : (
          <>
            {icon && iconPosition === "left" && icon}
            {label}
            {icon && iconPosition === "right" && icon}
          </>
        )}
      </button>
    </div>
  );
};

export default Button;